import { Box, IconButton, styled } from '@mui/material';

export const MenuWrapperStyled = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    width: 350,
  },
}));

export const IconButtonStyled = styled(IconButton)({
  padding: 0,
});

export const DrawerMobileVisibleStyled = styled('div')({
  marginLeft: 'auto',
  '@media (min-width: 744px)': {
    display: 'none',
  },
});
